/* import __COLOCATED_TEMPLATE__ from './in-app-messaging-connect.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type PulseAccordion } from 'glint/pulse';

interface Args {
  accordion: PulseAccordion;
  onContinue: () => void;
}

export default class StandaloneDeploySalesforceMessengerInAppMessagingConnect extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;

  get salesforceInAppMessagingConfig() {
    return this.finStandaloneService.salesforcePlatform.salesforceInAppMessagingConfig;
  }

  get isComplete() {
    return this.salesforceInAppMessagingConfig?.isConnected || false;
  }

  get isDisabled() {
    return this.finStandaloneService.salesforcePlatform.salesforceConfig?.isPendingSetup || false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Messenger::InAppMessagingConnect': typeof StandaloneDeploySalesforceMessengerInAppMessagingConnect;
    'standalone/deploy/salesforce/messenger/in-app-messaging-connect': typeof StandaloneDeploySalesforceMessengerInAppMessagingConnect;
  }
}
